// src/components/Comptable/documents/DocumentCard.jsx (ou votre chemin)
import React from 'react';
import { Card, CardActionArea, Box, Typography, useTheme } from '@mui/material';

const DocumentCard = ({ title, icon, onClick }) => {
    const theme = useTheme();

    return (
        <Card
            sx={{
                height: '100%',
                backgroundColor: 'background.paper', 
                borderRadius: 3, 
                transition: 'all 0.3s ease-in-out',
                border: '1px solid',
                borderColor: 'rgba(255, 255, 255, 0.12)',
                '&:hover': {
                    transform: 'translateY(-5px)',
                    borderColor: theme.palette.secondary.main, 
                    boxShadow: `0 10px 25px rgba(0, 0, 0, 0.3)`,
                },
            }}
        >
            <CardActionArea 
                onClick={onClick} 
                sx={{ 
                    height: '100%', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center', 
                    p: 4 
                }}
            >
                <Box
                    sx={{
                        width: 80,
                        height: 80,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 3,
                        background: `linear-gradient(145deg, ${theme.palette.primary.main}, ${theme.palette.background.paper})`,
                        boxShadow: 'inset 0 0 10px rgba(0,0,0,0.5)',
                    }}
                >
                    {React.cloneElement(icon, { 
                        sx: { 
                            fontSize: 40, 
                            color: theme.palette.secondary.main 
                        } 
                    })}
                </Box>
                <Typography
                    variant="h6"
                    component="h3"
                    sx={{
                        color: 'text.primary', 
                        fontWeight: 600,
                        textAlign: 'center',
                    }}
                >
                    {title}
                </Typography>
            </CardActionArea>
        </Card>
    );
};

export default DocumentCard;